/**
 * Toggle a specific group open/closed
 * @param {AccordionState} currentState - Current accordion state
 * @param {string} groupId - The group ID to toggle
 * @returns {AccordionState} New accordion state
 */
export const toggleGroup = (currentState, groupId) => ({
  ...currentState,
  [groupId]: !(currentState[groupId] ?? true),
});

/**
 * Initialize accordion state with default values for groups
 * @param {string[]} groupIds - Array of group IDs to initialize
 * @param {boolean} [defaultOpen=true] - Default state for groups (open/closed)
 * @returns {AccordionState} Initialized accordion state
 */
export const initializeAccordionState = (groupIds, defaultOpen = true) => {
  /** @type {AccordionState} */
  const initialState = {};
  groupIds.forEach((groupId) => {
    initialState[groupId] = defaultOpen;
  });
  return initialState;
};
